export const getAtlasTicket = (experimentValue: string) => {
    if (experimentValue === "jfind-1506-after-d7-gubtp-organic") {
        return "ATLAS-93656";
    } else {
        return "ATLAS-76385";
    }
};
